(() => {
    window.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll('.historybackbutton').forEach((button) => {
            button.addEventListener('click', () => {
                history.back();
            })
        })
    })
}) ()
